const stripHtmlTags = (html: string) => html.replace(/<[^>]*>/g, "").trim();

/** True when Write My Summary has real experience (or a substantial summary) to draw from. */
export function resumeHasRealWork(data: {
  sections?: Record<string, { items?: unknown[]; content?: unknown } | undefined>;
}): boolean {
  const experience = Array.isArray(data.sections?.experience?.items)
    ? data.sections.experience.items
    : [];
  if (
    experience.some((item) => {
      if (!item || typeof item !== "object") return false;
      const row = item as { company?: unknown; position?: unknown };
      const company = typeof row.company === "string" ? row.company.trim() : "";
      const position = typeof row.position === "string" ? row.position.trim() : "";
      return company.length > 0 || position.length > 0;
    })
  ) {
    return true;
  }
  const summary = data.sections?.summary?.content;
  return typeof summary === "string" && stripHtmlTags(summary).length > 40;
}
